import { TopicType  } from '@shared/enums/topic-type';
import { Quest } from '../quest';

export class GumQuest extends Quest {
  detailKey = 'digitalResourcesGumQuestDetail';
  topicKey: string;
  topicType: TopicType;
  name?: string;
  score?: string;
  activityId?: string;
  updatedOn: Date | string;

  constructor(data?: {[key: string]: any}) {
    super(data);
    if (data) {
      this.setAllowedProperties(data, this.detailKey);
    }
  }

  getAllowedPropertyNames(): string[] {
    return [
      'activityId',
      'name',
      'topicKey',
      'topicType',
    ];
  }

  label(): string {
    return this.description ? this.description : `${this.topicType} - ${this.name}`;
  }

  typeLabel(): string {
    return 'Grammar, Usage, & Mechanics Activity';
  }
}
